/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";
import { colors } from "../../../constants/colors";

const Content = (props) => {
  const { onSave, onCancel } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div>
      <div className={classes.btnContainer}>
        <UCButton
          onClick={onCancel}
          type="default"
          className={classes.cancelBtn}
          text={<FormattedMessage id="policyUnsavedChangesModal.cancel" />}
        />
        <UCButton
          className={classes.saveBtn}
          onClick={onSave}
          type="primary"
          text={<FormattedMessage id="policyUnsavedChangesModal.save" />}
          spinner={{
            name: "editPolicySpinner",
            size: 20,
            color: colors.white,
          }}
        />
      </div>
    </div>
  );
};

export default Content;
